import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classnames from 'classnames/bind';
import getTeam from '~/util/getPlayerTeam';

import StyledComponent from '~/components/Styled/Styled';
import css from '~/components/PlayerHeadshot/PlayerHeadshot.scss';

const cssContext = classnames.bind(css);
const playerHasTransparentHeadshots = player => get(player, 'has_transparent_headshots', false);
const playerHasHeadshots = player => get(player, 'has_headshots', false);
const getTransparentHeadshot = (player, size) => get(player, `headshots.transparent_${size}`, null);
const getTeamColour = (player, team) => get(team || getTeam(player), 'colour_1', '');
const getInitials = player => {
  const firstInitial = get(player, 'first_name[0]', '');
  const lastInitial = get(player, 'last_name[0]', '');
  return `${firstInitial} ${lastInitial}`.trim();
};
const renderHeadshot = (player, size) => {
  let headshotSize = size;
  if (size === 'bixby' || size === 'leaders' || size === 'tiny') headshotSize = 'small';

  if (!playerHasHeadshots(player) && playerHasTransparentHeadshots(player)) {
    return null;
  }
  if (playerHasTransparentHeadshots(player)) {
    return (
      <img
        className={css.image}
        src={getTransparentHeadshot(player, headshotSize)}
        alt={`${player.full_name} headshot`}
      />
    );
  }
  return null;
};
const renderLogo = (logo, teamName) => (
  <img className={css.teamLogo} src={logo} alt={`${teamName} logo`} />
);

class PlayerHeadshot extends React.PureComponent {
  render() {
    const { player, size, team } = this.props;
    const isMedium = size === 'medium';
    const isAuthor = size === 'author';
    const isBixby = size === 'bixby';
    const isTiny = size === 'tiny';
    const isLeaders = size === 'leaders';
    const containerClasses = cssContext(css.imageContainer, {
      small: !isMedium && !isAuthor && !isTiny,
      medium: isMedium,
      author: isAuthor,
      bixby: isBixby,
      leaders: isLeaders,
      tiny: isTiny,
    });

    return (
      <div className={containerClasses}>
        {renderHeadshot(player, size)}
        {!renderHeadshot(player, size) && player ? (
          <div className={css.playerInitialsContainer}>
            <div className={css.playerInitials}>{getInitials(player)}</div>
          </div>
        ) : null}
        {!renderHeadshot(player, size) && !player && team ? (
          <div className={css.teamLogoContainer}>
            {renderLogo(team.logos.small, team.full_name)}
          </div>
        ) : null}
        <div
          className={css.headshotBackground}
          style={{ backgroundColor: `#${getTeamColour(player, team)}` }}
        />
      </div>
    );
  }
}

PlayerHeadshot.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'author', 'bixby', 'leaders', 'tiny']),
  player: PropTypes.shape({
    full_name: PropTypes.string,
    headshots: PropTypes.object,
    teams: PropTypes.arrayOf(
      PropTypes.shape({
        colour_1: PropTypes.string,
      })
    ),
  }).isRequired,
  team: PropTypes.shape({
    colour_1: PropTypes.string,
  }),
};

PlayerHeadshot.defaultProps = {
  size: 'small',
  team: null,
};

PlayerHeadshot.displayName = 'PlayerHeadshot';

export default StyledComponent(PlayerHeadshot, [css]);
